import { MobileDrawer } from '@components/MobileDrawer/MobileDrawer';
import classNames from 'classnames';
import css from './MobileActionDrawer.module.scss';

export interface ActionDrawerItem<T extends string = string> {
  id: T;
  label: string;
  icon: React.ReactNode;
  danger?: boolean;
  disabled?: boolean;
}

interface MobileActionDrawerProps<T extends string> {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
  title: string;
  actions: ActionDrawerItem<T>[];
  onAction: (id: T) => void;
}

export function MobileActionDrawer<T extends string>({
  open,
  onClose,
  onOpen,
  title,
  actions,
  onAction,
}: MobileActionDrawerProps<T>) {
  return (
    <MobileDrawer open={open} onClose={onClose} onOpen={onOpen} frosted>
      <div className={css.content}>
        <span className={css.title}>{title}</span>
        <div className={css.actions}>
          {actions.map((action) => (
            <button
              key={action.id}
              className={classNames(css.actionItem, {
                [css.danger]: action.danger,
                [css.disabled]: action.disabled,
              })}
              disabled={action.disabled}
              onClick={() => {
                onAction(action.id);
                onClose();
              }}
            >
              <span className={css.actionIcon}>{action.icon}</span>
              <span className={css.actionLabel}>{action.label}</span>
            </button>
          ))}
        </div>
      </div>
    </MobileDrawer>
  );
}
